import {NavLink, useParams} from "react-router-dom";
import api from "../../api";
import Header from "./Components/Header";
import {useEffect, useRef, useState} from "react";
import {BlogsData} from "../types/Page";
import PageHero from "./Components/PageHero";
import FooterWithSignup from "./Components/FooterWithSignup";
import '../../styles/Blogs.scss'
import blogsTag from '../../assets/images/Stories Hacks And Fresh Insights.svg';
import {IMAGE_URL} from "../../path";

function Blogs() {
    const [blogData, setBlogData] = useState<BlogsData | null>(null);
    const [optionsOpen, setOptionsOpen] = useState<boolean>(false);
    const filterRef = useRef<HTMLDivElement>(null);

    const { slug } = useParams();
    async function fetchBlogs(pageNumber = 1) {
        try {
            let res;

            if (slug) {
                res = await api.get(`/v1/blogs/${slug}?page=${pageNumber}`);
            } else {
                res = await api.get(`/v1/blogs?page=${pageNumber}`);
            }

            setBlogData(res.data);
        } catch (error) {
            console.error(error);
        }
    }

    function handlePageChange(pageNumber: number) {
        fetchBlogs(pageNumber);
    }

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (
                filterRef.current &&
                !filterRef.current.contains(event.target as Node)
            ) {
                setOptionsOpen(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        fetchBlogs();
    }, [slug]);
    return (
        <div className="blogs">
            <Header />
            {blogData && blogData.page && blogData.page.headers && (
                <PageHero page="news" headers={blogData.page.headers} />
            )}

            {blogData && blogData.blogs && (
                <div className="blogs-container">
                    <div className="blogs-tag">
                        <img src={blogsTag} alt="Blogs Tag" />
                    </div>

                    {/*  Filter on the Right  */}
                    <div className="news-filter">
                        <p className="news-filter-description">
                            From kitchen counter to cleaning cupboard South Africa’s most trusted
                            vinegar brand, reimagined for modern living.
                        </p>

                        <div className="filter-box" ref={filterRef}>
                            <button
                                type="button"
                                className="filter-toggle"
                                onClick={() => setOptionsOpen(!optionsOpen)}
                            >
            <span>
                Filter By:{" "}

                    {slug
                        ? blogData.blog_categories.find(
                        (category) => category.slug === slug
                    )?.name || "All"
                        : "All"}

            </span>

                                <span className={`filter-arrow ${optionsOpen ? "open" : ""}`}>
            </span>
                            </button>

                            {optionsOpen && (
                                <div className="filter-options">
                                    <NavLink
                                        to="/news"
                                        onClick={() => setOptionsOpen(false)}
                                    >
                                        All
                                    </NavLink>

                                    {blogData.blog_categories.map((category) => (
                                        <NavLink
                                            key={category.id}
                                            to={`/news/${category.slug}`}
                                            onClick={() => setOptionsOpen(false)}
                                        >
                                            {category.name}
                                        </NavLink>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="blogs-grid">
                        <div className="blogs-grid-inner">

                            {blogData.blogs.data.map((blog) => (
                                <article
                                    className="blog-card"
                                    key={blog.id}
                                >
                                    <div className="blog-image">
                                        <img
                                            src={`${IMAGE_URL}/${blog.preview_image}`}
                                            alt={blog.title}
                                        />
                                    </div>

                                    {blog.category?.icon && (
                                        <div className="blog-category-icon">
                                            <img
                                                src={`${IMAGE_URL}/${blog.category.icon}`}
                                                alt={blog.category.name}
                                            />
                                        </div>
                                    )}

                                    <div className="blog-content">

                                        <div className="blog-read-time">
                                            {blog.read_time} min read
                                        </div>

                                        <h3>
                                            {blog.title}
                                        </h3>

                                        <p>
                                            {blog.subtitle}
                                        </p>

                                        <NavLink
                                            to={`/blog/${blog.slug}`}
                                            className="blog-read-more"
                                        >
                                            Read More
                                        </NavLink>

                                    </div>
                                </article>
                            ))}

                        </div>
                    </div>

                    {/*  Blogs Pagination  */}
                    <div className="pagination">

                        <button
                            type="button"
                            disabled={blogData.blogs.current_page === 1}
                            onClick={() => handlePageChange(blogData.blogs.current_page - 1)}
                            className="pagination-arrow"
                        >
                            &lt;
                        </button>

                        {Array.from(
                            { length: blogData.blogs.last_page },
                            (_, index) => index + 1
                        ).map((page) => (
                            <button
                                key={page}
                                type="button"
                                className={`pagination-number ${
                                    page === blogData.blogs.current_page ? "active" : ""
                                }`}
                                onClick={() => handlePageChange(page)}
                            >
                                {page}
                            </button>
                        ))}

                        <button
                            type="button"
                            disabled={blogData.blogs.current_page === blogData.blogs.last_page}
                            onClick={() => handlePageChange(blogData.blogs.current_page + 1)}
                            className="pagination-arrow"
                        >
                            &gt;
                        </button>

                    </div>
                </div>
            )}

            <FooterWithSignup />
        </div>
    )
}

export default Blogs;
